module.exports = __webpack_public_path__ + "img/33_40.48fcaec4.png";